import { service, service1 } from "@/request/request";

//随机土味情话
export const mokeGet = () => {
    return service({
        url: 'https://api.uomg.com/api/rand.qinghua',
        method: 'get',
    })
}

export const userGet = () => {
    return service({
        // url: '/api/user/login',
        url: '/api/getUsers',
        method: 'get',
        data: {
            username: 'system',
            password: '111111',
        }
    })
}

//获取课程检索
export const getCourseCategoryTree = () => {
    return service({
        url: '/course/getCourseCategoryTree',
        method: 'get'
    });
};

// 获取首页课程榜单
export const getHomeTopCourse = () => {
    return service({
        url: "/course/getHomeTopCourse",
        method: "get",
    })
}

// 获取首页分类课程
export const getHomeCourseByType = (params) => {
    return service({
        url: '/course/getHomeCourseByType',
        method: 'get',
        params
    });
};

//获取第一级分类
export const getFirstCourseCategory = (data) => {
    return service({
        url: "/course/getFirstCourseCategory",
        method: "get",
        data: data,
    });
};

//获取精彩课程
export const getRecommendCourseList = (data) => {
    return service({
        url: "/course/getRecommendCourseList",
        method: "get",
        params: data,
    });
};

//获取课程详情初始化数据
export const initCourseDetail = (data) => {
    return service({
        url: "/course/initCourseDetail",
        method: "get",
        params: data,
    });
};

//记录页面浏览量(未登录)
export const pageViewLog = (data) => {
    return service({
        url: "/system/pageViewLog",
        method: "get",
        params: data,
    });
};

//记录页面浏览量
export const loginedPageViewLog = (data) => {
    return service1({
        url: "/system/login/pageViewLog",
        method: "get",
        params: data,
    });
};

//获取轮播图数据
export const getIndexCarouselList = (data) => {
    return service({
        url: "/carousel/index/list",
        method: "get",
        params: data,
    });
};

//获取精彩赛事数据
export const getWonderfulCompetitionList = (data) => {
    return service({
        url: "/competition/getWonderfulCompetitionList",
        method: "get",
        params: data,
    });
};

//获取机构下拉框
export const getAgencySelect = (data) => {
    return service({
        url: "/agency/selectAgencySelectedNoToken",
        method: "get",
        params: data,
    });
};

//绑定机构
export const binderAgency = (id) => {
    return service1({
        url: "/user/binderAgency/" + id,
        method: "get",
    });
};

//选择机构
export const clickAgency = (data) => {
    return service1({
        url: "/agency/clickAgency",
        method: "get",
        params: data
    });
};

//查询机构是否授权到期
export const getAgencyExpire = (data) => {
    return service({
        url: "/agency/getAgencyExpire",
        method: "get",
        params: data
    });
};

//查询机构是否购买
export const getAgencyBuyIf = (data) => {
    return service({
        url: "/agency/getAgencyBuyIf",
        method: "get",
        params: data
    });
};
//站点信息初始化（仅该接口返回体为密文时启用解密；若请求参数也需加密可改为 apiCrypto: true）
export const getSiteInfoByOrgCode = (data) => {
    return service({
        url: "/course/getSiteInfoByOrgCode",
        method: "get",
        params: data,
        apiCrypto: "response",
    });
};

// Header 友情链接（按机构授权）
export const listFriendLinkForHeader = () => {
    return service({
        url: "/friend-link/listForHeader",
        method: "get",
    });
};


//建立sse连接
export const sseConnect = (data) => {
    return service({
        url: "/sse/connect",
        method: "get",
        params: data
    });
};

//建立sse连接
export const sseDisconnect = (data) => {
    return service1({
        url: "/sse/disconnect",
        method: "get",
        params: data
    });
};

export const getAgencyIdByIpScope = (data) => {
    return service({
        url: "/agency/getAgencyIdByIpScope",
        method: "get",
        params:data
    });
};
